import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DashboardFacade } from '../store/dashboard.facade';

@Component({
  selector: 'app-expiresonwidget',
  templateUrl: './expiresonwidget.component.html',
  styleUrls: ['./expiresonwidget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExpiresonwidgetComponent implements OnInit {

  public expireContracts$ = this.dashboardFacade$.expireContracts$;
  constructor(private dashboardFacade$: DashboardFacade) { }

  ngOnInit(): void {
    this.dashboardFacade$.fetchExpireContracts();
  }

}
